import React, { useCallback, useState } from 'react';

import useId from 'utils/hooks/useId';
import { TooltipProvider } from './context';
import TooltipTrigger from './TooltipTrigger';
import TooltipContent from './TooltipContent';

export default function Tooltip({ disabled = false, children = null }) {
  const id = useId('tooltip');
  const [isMounted, setIsMounted] = useState(false);

  const onMount = useCallback(() => setIsMounted(!disabled), [disabled]);

  return (
    <TooltipProvider value={{ id, isMounted, onMount }}>
      {children}
    </TooltipProvider>
  );
}

Tooltip.Trigger = TooltipTrigger;
Tooltip.Content = TooltipContent;
